import { Box, Button, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { generateResponsiveStyle } from "../utils/authModalStyle";

type props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    handleDelete: () => void;
    name: string;
};

const WarnModal = ({ open, setOpen, handleDelete, name }: props) => {

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="logout_mdl"
        >
            <Box sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "#ffff",
                // border: "1px solid #fff",
                boxShadow: 24,
                p: 6,
                borderRadius: 3,
                outline: "none",
            }}>
                <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ textAlign: "center", fontSize: "20px", color: "#000000" }}
                >
                    Are you sure you want to delete this {name}?
                </Typography>

                <div className="flexdiv">
                    <Box sx={{textAlign:"center"}}>
                        <Button
                            // className="yesBtn"
                            sx={{ color: "#ffffff", border: "1px solid #252525", bgcolor: "#29AB87", margin: "5px" }}
                            onClick={() => {
                                setOpen(false);
                                handleDelete();
                            }}
                        >
                            Yes
                        </Button>

                        <Button
                            sx={{ color: "#ffffff", border: "1px solid #252525", bgcolor: "#29AB87", margin: "5px" }}
                            onClick={() => setOpen(false)}
                        >
                            No
                        </Button>
                    </Box>

                </div>
            </Box>
        </Modal >
    );
};

export default WarnModal;
